import { IImportLeadPayload } from '../types/api';

import { isSuccessPage, isUpsellPage } from './navigation';

type UpsellKeyField =
  | 'custom_order_promo1'
  | 'custom_order_promo2'
  | 'custom_order_promo3'
  | 'custom_order_promo4';

export const getUpsellKey = (url?: string) => {
  const urlInput = url || window.location.href;
  const urlObject = new URL(urlInput);
  const pathSegments = urlObject.pathname
    .split('/')
    .filter(segment => segment !== '');
  const upsellPage = pathSegments[0] || '';
  const lastChar = upsellPage.charAt(upsellPage.length - 1);
  const upsellKey = parseInt(lastChar, 10) - 1;
  if (typeof upsellKey === 'number' && !isNaN(upsellKey)) {
    return upsellKey;
  }
  return undefined;
};

export const getUpsellCustomField = (
  upsellKeyOverride?: number,
): UpsellKeyField | undefined => {
  const upsellKey = upsellKeyOverride || getUpsellKey();
  if (typeof upsellKey === 'number') {
    return `custom_order_promo${upsellKey + 1}` as UpsellKeyField;
  }
  return undefined;
};

export const getPromoFieldName = (no?: number): UpsellKeyField | undefined => {
  if (typeof no === 'number') {
    return `custom_order_promo${no + 1}` as UpsellKeyField;
  } else if (isUpsellPage(1)) {
    return 'custom_order_promo1';
  } else if (isUpsellPage(2)) {
    return 'custom_order_promo2';
  } else if (isUpsellPage(3)) {
    return 'custom_order_promo3';
  } else if (isUpsellPage(4)) {
    return 'custom_order_promo4';
  }
  return undefined;
};

export const getProductIdToReport = (lead: IImportLeadPayload) => {
  if (isUpsellPage(1)) {
    return lead.initial;
  } else if (isUpsellPage(2)) {
    return lead.promo1;
  } else if (isUpsellPage(3)) {
    return lead.promo2;
  } else if (isUpsellPage(4)) {
    return lead.promo3;
  } else if (isSuccessPage()) {
    const upsellKey = getUpsellKey(document.referrer);
    if (typeof upsellKey === 'number') {
      const promoField = `promo${upsellKey + 1}` as keyof IImportLeadPayload;
      return lead[promoField];
    }
    return undefined;
  }
  return undefined;
};
